/* @flow */
/* eslint-disable babel/no-invalid-this */
import Schema from "nexia_mobile/models/schema";
import type { SprinklerFeature } from "./types";

export default function Sprinkler(feature: SprinklerFeature) {
  let standbyAction = feature.actions.standby_mode;
  let waterZonesAction = feature.actions.water_zones;
  let stopWaterAction = feature.actions.stop_water;

  // let rachio decide name
  this.isNameEditable = () => false;

  this.inStandbyMode = () => {
    return this.get("standby_mode");
  };

  this.enableStandbyMode = (yesno) => {
    return this.executeDeviceAction(
      standbyAction,
      { value: yesno },
      { updateModelWithResponse: false }
    ).then(() => {
      return this.fetchDetails();
    });
  };

  this.fetchWaterZonesSchema = () => {
    return this.executeDeviceAction(
      waterZonesAction,
      {},
      { updateModelWithResponse: false }
    ).then((data) => new Schema(data, { parse: true }));
  };

  this.stopWater = () => {
    return this.executeDeviceAction(
      stopWaterAction,
      {},
      { updateModelWithResponse: false }
    ).then(() => {
      return this.fetchDetails();
    });
  };

  return {};
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/sprinkler.js